import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class GlobalSidenavService {
	public visible = signal<boolean>(false);
}
